export default Object.freeze({
	HOST_CLICK: 'szn.discussion.to.embed.hostClick',
	BOUNDING_RECT_CHANGE: 'szn.discussion.to.embed.boundingRectChange',
	SCROLL_DONE: 'szn.discussion.to.embed.scrollCompleted',
	CONFIRMED: 'szn.discussion.to.embed.confirmed',
	SHARED: 'szn.discussion.to.embed.shared',
	MODAL_CLOSED: 'szn.discussion.to.embed.modalClosed',
	LOGIN: 'szn.discussion.to.embed.login',
	LOGOUT: 'szn.discussion.to.embed.logout',
	OAUTH_FAIL: 'szn.discussion.to.embed.oauthFailed'
});
